module.exports = __webpack_public_path__ + "files/fd60cae4302f09bdb3fbd7321ec1409a.svg";